/* 🤖 this file was generated by svg-to-ts */
export const matIconFilter3: {
  name: 'filter-3';
  data: string;
} = {
  name: 'filter-3',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M21 1H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 16H7V3h14v14zM3 5H1v16c0 1.1.9 2 2 2h16v-2H3V5zm14 8v-1.5c0-.83-.67-1.5-1.5-1.5.83 0 1.5-.67 1.5-1.5V7a2 2 0 0 0-2-2h-4v2h4v2h-2v2h2v2h-4v2h4a2 2 0 0 0 2-2z"/></svg>`
};
